import {DetailsList, FontSizes, FontWeights, SelectionMode, Stack} from "@fluentui/react";
import * as React from "react";
import ProjectLink from "../Components/ProjectLink";
import {MoneyField} from "../Utilities/MoneyField";
import { netGrossColumn, useNetGross } from "../Utilities/NetGrossField";
import { useEffect, useState } from "react";

function PersonTransactionList(props) {
    const netGross = useNetGross();
    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
        {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 300,
            isRowHeader: true,
            isResizable: false,
            onRender: ProjectLink
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 250,
            isResizable: false,
        },
        {
            ...netGrossColumn()
        }
        ]);
    }, [netGross]);

    return (<Stack.Item>
        <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
        <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
    </Stack.Item>);
}

PersonTransactionList.defaultProps = {
    title: 'Projekty'
}

export default PersonTransactionList;